import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';
import __vue_component__ from '../HseCheckbox/HseCheckbox.vue.js';
import __vue_component__$1 from '../HseDropdownMenu/HseDropdownMenuItem.vue.js';

var HseSelectOption = /** @class */ (function (_super) {
    __extends(HseSelectOption, _super);
    function HseSelectOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HseSelectOption.prototype.refRoot = function () {
        return this.$refs.item.refRoot();
    };
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSelectOption.prototype, "hasCheckbox", void 0);
    HseSelectOption = __decorate([
        Component({
            name: 'HseSelectOption',
            components: {
                HseCheckbox: __vue_component__,
                HseDropdownMenuItem: __vue_component__$1
            }
        })
    ], HseSelectOption);
    return HseSelectOption;
}(Vue));

export default HseSelectOption;
